/** Stable sortable ids tied to current FAQ array indices (indices update after reorder). */
export function faqSectionSortId(index: number): string {
  return `faq-section-${index}`;
}

export function faqRowSortId(sectionIndex: number, rowIndex: number): string {
  return `faq-row-${sectionIndex}-${rowIndex}`;
}
